/* MINIFLACONS · PDP Lab · Shop-Module (Datenpool, Duft-Zwillinge, 3 für 2, Gutschrift) */
(() => {
  'use strict';
  const MFL = window.MFL;
  if (!MFL || !MFL.data || !MFL.fx) return;
  const D = MFL.data, root = MFL.root, money = MFL.money;
  const { FAMC, esc, clamp } = MFL.fx;
  const $ = (s, el = root) => el.querySelector(s);

  /* ------------------------------------------------ Datenpool (Quiz-Datenquelle) */
  const pools = {};
  function loadPool(handle) {
    if (!handle) return Promise.resolve([]);
    if (pools[handle]) return pools[handle];
    const key = 'mfl_pool_' + handle;
    try { const c = JSON.parse(sessionStorage.getItem(key)); if (c && c.p && c.p.length && Date.now() - c.t < 30 * 60e3) return (pools[handle] = Promise.resolve(c.p)); } catch (e) {}
    return (pools[handle] = (async () => {
      let page = 1, pages = 1, out = [];
      do {
        const r = await fetch(`/collections/${encodeURIComponent(handle)}?view=mfq-data&page=${page}`, { credentials: 'same-origin' });
        if (!r.ok) break;
        const j = await r.json();
        pages = Math.min(j.pages || 1, 4); out = out.concat(j.products || []); page++;
      } while (page <= pages);
      if (out.length) try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), p: out })); } catch (e) {}
      return out;
    })().catch(() => []));
  }
  const norm = s => String(s || '').toLowerCase().trim();
  const meVec = MFL.vec(D.dr || []);
  const meGn = new Set((D.gn || []).map(norm));
  function similarity(b) {
    const c = MFL.cos(meVec, MFL.vec(b.dr || []));
    const gb = [...new Set((b.gn || []).map(norm))];
    const shared = (b.gn || []).filter(x => meGn.has(norm(x)));
    const uni = new Set([...meGn, ...gb]).size || 1;
    const jac = Math.min(1, (shared.length / uni) * 2.2);
    const perf = 1 - (Math.abs((+D.sil || 0) - (+b.sil || 0)) + Math.abs((+D.halt || 0) - (+b.halt || 0))) / 20;
    return { s: clamp(.6 * c + .3 * jac + .1 * perf), shared };
  }
  const sampleOf = (b, onlyMl) => (b.var || []).map(v => Object.assign({}, v, MFL.classify({ title: v.t })))
    .filter(v => v.kind === 'sample' && v.a && v.p > 0 && (!onlyMl || v.ml === onlyMl))
    .sort((x, y) => x.ml - y.ml)[0];
  const PLUS = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>';
  const CHECK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  /* ------------------------------------------------ Duft-Zwillinge */
  const twins = $('[data-mfl-twins]');
  if (twins && D.cfg && D.cfg.twinsSource) {
    const track = $('[data-mfl-twins-track]', twins);
    let loaded = false;
    const load = async () => {
      if (loaded) return; loaded = true;
      const list = await loadPool(D.cfg.twinsSource);
      const ranked = list.filter(b => b.id !== D.id && b.img && (b.dr || []).length)
        .map(b => Object.assign({ b, v: sampleOf(b) }, similarity(b)))
        .filter(x => x.v)
        .sort((a, b) => b.s - a.s).slice(0, 10);
      if (ranked.length < 3) return;
      track.innerHTML = ranked.map((x, n) => {
        const b = x.b, pct = Math.round(x.s * 100), c = FAMC[(b.dr || [])[0]] || '#ccc';
        return `<a class="mfl-twin" href="${esc(b.url)}" style="--n:${n};--c:${c}">
          <span class="mfl-twin__media"><img src="${esc(b.img)}" alt="${esc(b.t)}" loading="lazy" width="400" height="400">
            <span class="mfl-twin__sim" style="--s:${pct}"><i></i>${pct} % ähnlich</span></span>
          <span class="mfl-twin__body">
            <span class="mfl-twin__vendor">${esc(b.v)}</span>
            <span class="mfl-twin__title">${esc(b.t)}</span>
            <span class="mfl-twin__shared">${(x.shared.length ? x.shared.slice(0, 3) : (b.dr || []).slice(0, 2)).map(s => `<span>${esc(s)}</span>`).join('')}</span>
            <span class="mfl-twin__foot">
              <span class="mfl-twin__price"><small>${esc(x.v.t)} · </small><b>${money(Math.round(x.v.p * 100))}</b></span>
              <button type="button" class="mfl-twin__add" data-mfl-quick="${x.v.id}" aria-label="${esc(x.v.t)} ${esc(b.t)} in den Warenkorb">${PLUS}</button>
            </span>
          </span></a>`;
      }).join('');
      twins.hidden = false;
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([e], o) => { if (e.isIntersecting) { o.disconnect(); load(); } }, { rootMargin: '700px 0px' }).observe(twins.previousElementSibling || root);
    } else load();
    track.addEventListener('click', async e => {
      const b = e.target.closest('[data-mfl-quick]');
      if (!b) return;
      e.preventDefault(); e.stopPropagation();
      b.disabled = true;
      try { await MFL.addItems([{ id: +b.dataset.mflQuick, quantity: 1 }]); b.classList.add('is-done'); b.innerHTML = CHECK; }
      catch (err) { b.disabled = false; }
    });
    const nav = d => track.scrollBy({ left: d * (track.clientWidth * .8), behavior: 'smooth' });
    const pv = $('[data-mfl-twins-prev]', twins), nx = $('[data-mfl-twins-next]', twins);
    if (pv) pv.addEventListener('click', () => nav(-1));
    if (nx) nx.addEventListener('click', () => nav(1));
  }

  /* ------------------------------------------------ 3 für 2 · Trio */
  const trio = $('[data-mfl-trio]');
  let trioRanked = null, trioOff = 0;
  async function renderTrio() {
    if (!trio) return;
    const cur = MFL.current;
    if (!cur || cur.kind !== 'sample' || cur.ml !== 1 || !cur.available) { trio.hidden = true; return; }
    if (!trioRanked) {
      const list = await loadPool(D.cfg.trioPool);
      trioRanked = list.filter(b => b.id !== D.id && b.img)
        .map(b => Object.assign({ b, v: sampleOf(b, 1) }, similarity(b)))
        .filter(x => x.v).sort((a, b) => b.s - a.s).slice(0, 14);
    }
    if (trioRanked.length < 2) { trio.hidden = true; return; }
    const n = trioRanked.length, p1 = trioRanked[trioOff % n], p2 = trioRanked[(trioOff + 1) % n];
    const items = [
      { id: cur.id, t: D.title, v: D.vendor, img: D.img, price: cur.price, me: true },
      { id: p1.v.id, t: p1.b.t, v: p1.b.v, img: p1.b.img, price: Math.round(p1.v.p * 100), url: p1.b.url },
      { id: p2.v.id, t: p2.b.t, v: p2.b.v, img: p2.b.img, price: Math.round(p2.v.p * 100), url: p2.b.url }
    ];
    const sum = items.reduce((s, x) => s + x.price, 0);
    const free = Math.min(...items.map(x => x.price));
    let freeIdx = -1; for (let i = items.length - 1; i >= 0; i--) if (items[i].price === free) { freeIdx = i; break; }
    const card = (x, i) => `<${x.url ? 'a href="' + esc(x.url) + '"' : 'span'} class="mfl-trio__item" style="animation-delay:${i * 80}ms">
        ${i === freeIdx ? '<span class="mfl-trio__free">Gratis</span>' : ''}
        ${x.img ? `<img src="${esc(x.img)}" alt="" loading="lazy" width="52" height="52">` : ''}
        <b>${esc(x.t)}</b><small>${x.me ? 'dieser Duft' : esc(x.v)} · 1 ml</small>
        <em>${i === freeIdx ? `<s>${money(x.price)}</s>${money(0)}` : money(x.price)}</em>
      </${x.url ? 'a' : 'span'}>`;
    $('[data-mfl-trio-row]', trio).innerHTML = items.map(card).join('<span class="mfl-trio__plus" aria-hidden="true">+</span>');
    const add = $('[data-mfl-trio-add]', trio);
    add.innerHTML = `Trio · ${money(sum - free)}<s>${money(sum)}</s>`;
    add.dataset.ids = JSON.stringify([items[1].id, items[2].id]);
    add.classList.remove('is-loading');
    trio.hidden = false;
  }
  if (trio) {
    $('[data-mfl-trio-shuffle]', trio).addEventListener('click', () => { trioOff += 2; renderTrio(); });
    $('[data-mfl-trio-add]', trio).addEventListener('click', async e => {
      const b = e.currentTarget, cur = MFL.current;
      let ids = []; try { ids = JSON.parse(b.dataset.ids || '[]'); } catch (_) {}
      if (!cur || ids.length < 2) return;
      b.classList.add('is-loading');
      try {
        await MFL.addItems([{ id: cur.id, quantity: 1 }].concat(ids.map(id => ({ id, quantity: 1, properties: { _mf_duo: '1' } }))));
        b.innerHTML = 'Trio im Warenkorb ✓';
      } catch (err) { b.classList.remove('is-loading'); b.textContent = 'Nochmal versuchen'; }
    });
  }

  /* ------------------------------------------------ Flakon-Gutschrift */
  const credit = $('[data-mfl-credit]');
  function renderCredit() {
    if (!credit) return;
    const cur = MFL.current;
    const fls = D.variants.filter(v => v.kind === 'flakon');
    const fl = fls.filter(v => v.available).sort((a, b) => a.price - b.price)[0] || fls.sort((a, b) => a.price - b.price)[0];
    if (!cur || cur.kind !== 'sample' || !fl || !(D.cfg && D.cfg.credit)) { credit.hidden = true; return; }
    $('[data-mfl-credit-fl-label]', credit).textContent = `${fl.title.replace(/\s*ovp/i, '')} Flakon`;
    $('[data-mfl-credit-fl]', credit).textContent = money(fl.price);
    $('[data-mfl-credit-sample]', credit).textContent = money(cur.price);
    $('[data-mfl-credit-result]', credit).textContent = money(Math.max(0, fl.price - cur.price));
    credit.hidden = false;
  }

  const onVariant = () => { renderTrio(); renderCredit(); };
  document.addEventListener('mfl:variant', onVariant);
  onVariant();
})();